import React from 'react';
import { MetaTags } from 'react-meta-tags';
import { DashBreadcrumb } from '../../components/Common/Breadcrumb';
import { Col, Container, Row } from 'reactstrap';
import Error403 from '../../components/Common/Error403';
import STOrderList from './components/STOrderList';
import STExportReport from './components/STExportReport';

const STOrders = () => {
  let UserID = '';
  if (localStorage.getItem('authUser')) {
    const userObj = JSON.parse(localStorage.getItem('authUser'));
    if (userObj?.role_id !== undefined) {
      UserID = userObj?.user_id;
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>ST Orders</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col xl={6}>
              <DashBreadcrumb title="Orders" breadcrumbItem="ST Orders" />
            </Col>
            <STExportReport />
          </Row>
          {UserID !== '9' ? (
            <STOrderList />
          ) : (
            <Error403 />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default STOrders;
